import React, {forwardRef, useEffect, useState} from 'react'
import {modelUtils} from "@/utils";
import {connect} from "dva";
import {Card, Descriptions, Spin, Table} from 'antd'
import moment from "moment/moment";

import {useUpdateEffect} from "ahooks";
import {Session} from "wiz-utils";
import {AudienceGroupItem} from "@/components";


const Index = (
  {
    dispatch,

    detailRes,

    ReviewTaskLoading,
    ...props
  },
) => {
  const [id, setId] = useState();
  const [data, setData] = useState({})

  const {questions} = data || {}


  useEffect(() => {
    console.log('props', props)
    const {history} = props || {}
    const id = history?.location?.record?.id
    if (!!id) {
      setId(id)
      Session.set('reviewTaskLook', id)
    } else {
      setId(Session.get('reviewTaskLook'))
    }
  }, [])

  useUpdateEffect(() => {
    dispatch({
      type: "ReviewTask/getInfoById",
      payload: {
        key: "getInfoById",
        apiParams: {
          id: id,
        },
      },
    })
  }, [id])

  useUpdateEffect(() => {
    const {success, msg, data} = detailRes || {}
    if (!success) {
      wizNotice.error(msg || '系统运行繁忙');
      return;
    }
    setData(data)
  }, [detailRes])


  const totalScore = questions?.map(item => item?.score || 0).reduce((a, b) => a + b, 0)

  const columns = [
    {title: '题目类型', dataIndex: 'type', render: (text) => _getValue('type', text) || text},
    {title: '题目编码', dataIndex: 'number'},
    {title: '题目内容', dataIndex: 'title'},
    {title: '题目难度', dataIndex: 'difficulty', render: (text) => _getValue('difficulty', text) || text},
    {title: '题目分数', dataIndex: 'score'},
    {title: '通过分数', dataIndex: 'passScore'},
    {
      title: '计分模式',
      dataIndex: 'calcMode',
      render: (_, record) => {
        const {scoreRuleGain, ruleGainCount} = record || {}
        return scoreRuleGain > 0 ? `${ruleGainCount || 0}选${scoreRuleGain || 0}` : "权重"
      }
    }
  ]

  return (
    <Card>
      <Spin spinning={ReviewTaskLoading}>
        <Descriptions column={2} bordered={true}>
          <Descriptions.Item label={'任务名称'} span={2}>
            {data?.title}
          </Descriptions.Item>

          <Descriptions.Item label={'任务状态'}>
            {{0: '草稿', 1: '已发布', 2: '已关闭'}[data?.state] || data?.state}
          </Descriptions.Item>
          <Descriptions.Item label={'受众范围'}>
            <AudienceGroupItem {...data?.authInfo} isModal={true} btnText={'查看受众'}/>
          </Descriptions.Item>

          <Descriptions.Item label={'开始时间'}>
            {data?.startDate}
          </Descriptions.Item>
          <Descriptions.Item label={'结束时间'}>
            {data?.endDate}
          </Descriptions.Item>

          <Descriptions.Item label={'总分'}>
            {data?.totalScore || totalScore}
          </Descriptions.Item>
          <Descriptions.Item label={'通过分数'}>
            {data?.passScore}
          </Descriptions.Item>

          <Descriptions.Item label={'限制次数'}>
            {data?.times === 0 ? '无限制' : `${data?.times || 0}次`}
          </Descriptions.Item>
          <Descriptions.Item label={'限制时间'}>
            {data?.limitMinutes === 0 ? '无限制' : `${data?.limitMinutes || 0}分钟`}
          </Descriptions.Item>

          <Descriptions.Item label={'任务描述'} span={2}>
            {data?.intro}
          </Descriptions.Item>
          <Descriptions.Item label={'背景说明'} span={2}>
            {data?.backgroundNote}
          </Descriptions.Item>

          <Descriptions.Item label={'是否展示标准答案'}>
            {{0: '否', 1: '是'}[data?.showAnswer] || data?.showAnswer}
          </Descriptions.Item>
          <Descriptions.Item label={'是否展示得失分记录'}>
            {{0: '否', 1: '是'}[data?.showQuestionRule] || data?.showQuestionRule}
          </Descriptions.Item>

          <Descriptions.Item label={'开启人脸识别'}>
            {{0: '否', 1: '是'}[data?.openFace] || data?.openFace}
          </Descriptions.Item>
          <Descriptions.Item label={'开启声纹识别'}>
            {{0: '否', 1: '是'}[data?.openVoiceprint] || data?.openVoiceprint}
          </Descriptions.Item>
        </Descriptions>

        <br/>
        <Card title={'题目内容'}>
          <Table columns={columns} dataSource={questions}/>
        </Card>

      </Spin>
    </Card>
  )
}

const _getValue = (type, key) => {
  const values = {
    type: {
      0: '单选题',
      1: '多选题',
      2: '判断题',
      3: '填空题',
      4: '主观题',
      5: '主观题',
    },
    difficulty: {
      0: '低',
      1: '中',
      2: '高',
    },
  }
  return values[type][key]
}


const mapStateToProps = (state, ownProps) => {
  const {ReviewTask} = state;
  const getInfoById = modelUtils.getModelEntity(ReviewTask, "getInfoById");

  const loading = modelUtils.getLoadingState(state, ['ReviewTask']);

  return {
    detailRes: getInfoById,
    ...loading,
  }
};
export default connect(mapStateToProps, null, null, {forwardRef: true})(Index)

